import React, { useCallback } from 'react';
import styled from 'styled-components';

import { getPayloadFromToken } from 'zdocs-web-core/lib/token';
import {
  IFrameErrorTypes,
  ZDocsEditor,
  ZDocsEditorError,
} from '@zillow/zdocs-web/src/index';

import { Header, HEADER_HEIGHT } from './Header';

const StyledZDocsEditor = styled(ZDocsEditor)`
  margin: 0;
  padding: 0;
  outline: none;

  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    height: calc(100% - ${HEADER_HEIGHT});
  }
`;

interface Props {
  token: string;
  onError: () => void;
}

export default function StandaloneEditor({ token, onError }: Props) {
  const payload = getPayloadFromToken(token);
  const name = payload?.zdocs?.name ?? '';
  const standaloneEditorPort = '3003';
  const url =
    window.location.port === standaloneEditorPort
      ? window.location.href.replace(standaloneEditorPort, '3000')
      : window.location.href;
  const iFrameSrc = url.replace(/\/editor/, '/embed/editor');
  const handleEditorError = useCallback(
    (message: ZDocsEditorError) => {
      const { error } = message;

      const isErrorRecoverable =
        error === IFrameErrorTypes.PageImageError ||
        error === IFrameErrorTypes.SaveError;

      if (!isErrorRecoverable) {
        onError();
      }
    },
    [onError]
  );

  return (
    <React.Fragment>
      <Header name={name} />
      <StyledZDocsEditor
        title="zDocs - document editor"
        id="embedded-doc-editor"
        data-cy="embedded-doc-editor"
        url={iFrameSrc}
        onError={onError}
        onEditorError={handleEditorError}
      />
    </React.Fragment>
  );
}
